import { Difficulty, DifficultyModifiers } from '../types';

export const DIFFICULTY_MODIFIERS: Record<Difficulty, DifficultyModifiers> = {
  [Difficulty.EASY]: {
    playerHp: 150,
    regenRate: 8,
    zombieHpMultiplier: 0.7,
    zombieDamageMultiplier: 0.7,
    zombieSpeedMultiplier: 0.9,
    coinMultiplier: 0.8,
    detectionRangeMultiplier: 0.7,
  },
  [Difficulty.NORMAL]: {
    playerHp: 100,
    regenRate: 5,
    zombieHpMultiplier: 1.0,
    zombieDamageMultiplier: 1.0,
    zombieSpeedMultiplier: 1.0,
    coinMultiplier: 1.0,
    detectionRangeMultiplier: 1.0,
  },
  [Difficulty.HARD]: {
    playerHp: 75,
    regenRate: 3,
    zombieHpMultiplier: 1.5,
    zombieDamageMultiplier: 1.3,
    zombieSpeedMultiplier: 1.1,
    coinMultiplier: 1.5,
    detectionRangeMultiplier: 1.3,
  },
};
